import { effects } from 'redux-saga'

import callWithHmac from '../effects/callWithHmac'
import { begin, end } from '../../modules/loading'
import { receivePartners } from '../../modules/partner/reducer'

export default function* load({ invocation }) {
  try {
    yield effects.put.resolve(begin('partners'))

    const results = yield effects.call(callWithHmac, invocation.getPartners)

    yield effects.put.resolve(receivePartners(results.partners))
  } finally {
    yield effects.put.resolve(end('partners'))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/partner/load.js